import useSearchFilter from "hooks/useSearchFilter"
import PropTypes from "prop-types"
import React from "react"
import Month from "./Views/Month"
import Week from "./Views/Week"
import Day from "./Views/Day"

const getCalendarComponent = () => {
  return { month: Month, week: Week, date: Day }
}

const CalendarViewSwitcher = ({ onChangeFilters }) => {
  const [params] = useSearchFilter({ accessAttributes: ["range", "date"] })

  if (!params.date || !params.range) return null
  const Calendar = getCalendarComponent()[params.range]

  return <Calendar date={params.date} onChangeFilters={onChangeFilters} />
}

CalendarViewSwitcher.propTypes = {
  onChangeFilters: PropTypes.func.isRequired
}

export default CalendarViewSwitcher
